import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'app-registration-found-property-dialog',
    template: require('./registrationFoundProperty.html')
})
export class RegistrationFoundPropertyDialog {

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
                @Inject(MatDialogRef<RegistrationFoundPropertyDialog>) public dialogRef: MatDialogRef<RegistrationFoundPropertyDialog>) {
    }

    closeDialog(value: any) {
        this.dialogRef.close(value)
    }


}
